import gql from 'graphql-tag';

export default gql`
    mutation ValidateInventoryBox($input: ValidateInventoryBoxInput) {
        validateInventoryBox(input: $input) {
            errors
        }
    }
`;
